/* Imports */
import React, { useEffect } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

/* Chart code */
// Themes begin
am4core.useTheme(am4themes_animated);
// Themes end

function Chart({ data, showList }) {
  useEffect(() => {
    // Map instance
    let chart = am4core.create("chartpartidos", am4charts.XYChart);
    chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

    chart.paddingRight = 10;

    /*chart.data = [
      {
        name: "Monica",
        steps: 45688,
        href: "https://www.amcharts.com/wp-content/uploads/2019/04/monica.jpg",
      },
      {
        name: "Joey",
        steps: 35781,
        href: "https://www.amcharts.com/wp-content/uploads/2019/04/joey.jpg",
      },
      {
        name: "Ross",
        steps: 25464,
        href: "https://www.amcharts.com/wp-content/uploads/2019/04/ross.jpg",
      },
      {
        name: "Phoebe",
        steps: 18788,
        href: "https://www.amcharts.com/wp-content/uploads/2019/04/phoebe.jpg",
      },
      {
        name: "Rachel",
        steps: 15465,
        href: "https://www.amcharts.com/wp-content/uploads/2019/04/rachel.jpg",
      },
      {
        name: "Chandler",
        steps: 11561,
        href:
          "https://www.amcharts.com/wp-content/uploads/2019/04/chandler.jpg",
      },
    ];*/
    chart.data = data

    let categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "name";
    categoryAxis.renderer.grid.template.strokeOpacity = 0;
    categoryAxis.renderer.minGridDistance = 8;
    categoryAxis.renderer.labels.template.dx = -20;
    categoryAxis.renderer.minWidth = 50;
    categoryAxis.renderer.tooltip.dx = -20;
    

    let valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.inside = true;
    valueAxis.renderer.labels.template.fillOpacity = 0.3;
    valueAxis.renderer.grid.template.strokeOpacity = 0;
    valueAxis.min = 0;
    valueAxis.cursorTooltipEnabled = false;
    valueAxis.renderer.baseGrid.strokeOpacity = 0;
    valueAxis.renderer.labels.template.dy = 10;
    valueAxis.max = Math.max.apply(Math, data.map(function(o) { return o.steps; })) + 5
    valueAxis.strictMinMax = true;

    let series = chart.series.push(new am4charts.ColumnSeries());
    series.dataFields.valueX = "steps";
    series.dataFields.categoryY = "name";
    series.tooltipText = "{valueX.value}";
    series.tooltip.pointerOrientation = "vertical";
    series.tooltip.dy = -30;
    series.columnsContainer.zIndex = 100;
    

    let columnTemplate = series.columns.template;
    columnTemplate.height = am4core.percent(50);
    columnTemplate.maxHeight = 40;
    columnTemplate.column.cornerRadius(60, 10, 60, 10);
    columnTemplate.strokeOpacity = 0;
    chart.fontSize = 11
    columnTemplate.cursorOverStyle = am4core.MouseCursorStyle.pointer;


    series.heatRules.push({
      target: columnTemplate,
      property: "fill",
      dataField: "valueX",
      min: am4core.color("#9eddde"),
      max: am4core.color("#333366"),
    });
    series.mainContainer.mask = undefined;

    let cursor = new am4charts.XYCursor();
    chart.cursor = cursor;
    cursor.lineX.disabled = true;
    cursor.lineY.disabled = true;
    cursor.behavior = "none";

    let bullet = columnTemplate.createChild(am4charts.CircleBullet);
    bullet.circle.radius = 10;
    bullet.valign = "middle";
    bullet.align = "left";
    bullet.isMeasured = true;
    bullet.interactionsEnabled = false;
    bullet.horizontalCenter = "right";
    bullet.interactionsEnabled = false;

    let hoverState = bullet.states.create("hover");
    let outlineCircle = bullet.createChild(am4core.Circle);
    outlineCircle.adapter.add("radius", function (radius, target) {
      let circleBullet = target.parent;
      return circleBullet.circle.pixelRadius + 4;
    });

    let image = bullet.createChild(am4core.Image);
    image.width = 60;
    image.height = 60;
    image.horizontalCenter = "middle";
    image.verticalCenter = "middle";
    image.propertyFields.href = "href";

    image.adapter.add("mask", function (mask, target) {
      let circleBullet = target.parent;
      return circleBullet.circle;
    });

    let previousBullet;
    chart.cursor.events.on("cursorpositionchanged", function (event) {
      let dataItem = series.tooltipDataItem;

      if (dataItem.column) {
        let bullet = dataItem.column.children.getIndex(1);

        if (previousBullet && previousBullet != bullet) {
          previousBullet.isHover = false;
        }

        if (previousBullet != bullet) {
          let hs = bullet.states.getKey("hover");
          hs.properties.dx = dataItem.column.pixelWidth;
          bullet.isHover = true;

          previousBullet = bullet;
        }
      }
    });

    columnTemplate.events.on(
        'hit',
        function(ev) {
          // zoom to an object
          const namePartido = ev.target.dataItem.dataContext.name
          showList({label: namePartido, value: namePartido})
          //ev.target.series.chart.zoomToMapObject(ev.target)
          /*polygonSeries.data = [
          {
            id: ev.target.dataItem.dataContext.id,
            fill: am4core.color('#00a8ac')
          }
        ]*/

        },
        this
      )
  }, [data]);

  return (
    <div id="chartpartidos" style={{ width: "100%", height: "840px" }}></div>
  );
}

export default Chart;
